// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"ProgressTabs_progressBar__2XgK7","headings":"ProgressTabs_headings__1JT_4"};